module.exports = __webpack_public_path__ + "img/FPT15.0aca266c.svg";